import React from 'react';
import { Link } from 'react-router-dom';
import { IconMapPin, IconPhone, IconMail, IconClock } from './Icons';
import './Footer.css';

const CONTACT = [
  { Icon: IconMapPin, text: 'Sogamoso, Boyacá, Colombia' },
  { Icon: IconPhone, text: '312 376 6296 - 321 416 2832' },
  { Icon: IconMail, text: 'contacto@impactama.com' },
  { Icon: IconClock, text: 'Lun – Vie: 8:00 AM – 6:00 PM' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__grid">

          {/* Brand */}
          <div className="footer__brand">
            <Link to="/">
              <img src="/logo3.webp" alt="Impacta M.A. SAS" className="footer__logo-img" />
            </Link>
            <p className="footer__tagline" >
              Responsabilidad · Compromiso · Profesionalismo
            </p>
            <p className="footer__desc" align="left">
              Empresa especializada en consultoría minera y ambiental. Brindamos soluciones técnicas integrales con los más altos estándares de calidad y seguridad.
            </p>
          </div>

          {/* Servicios Minería */}
          <div className="footer__col">
            <h4 className="footer__title">Servicios Minería</h4>
            <ul className="footer__list">
              <li><Link to="/servicios/ventilacion">Planes de Ventilación</Link></li>
              <li><Link to="/servicios/sostenimiento">Planes de Sostenimiento</Link></li>
              <li><Link to="/servicios/metano-polvo">Prevención Metano y Polvo</Link></li>
              <li><Link to="/servicios/pto">PTO</Link></li>
              <li><Link to="/servicios/asesorias-mineras">Asesorías Mineras</Link></li>
            </ul>
          </div>

          {/* Servicios Ambientales */}
          <div className="footer__col">
            <h4 className="footer__title">Serv. Ambientales</h4>
            <ul className="footer__list">
              <li><Link to="/servicios/icas">ICAS</Link></li>
              <li><Link to="/servicios/estudios-aguas">Estudios de Aguas</Link></li>
              <li><Link to="/servicios/licencias">Licencias Ambientales</Link></li>
              <li><Link to="/servicios/pma">PMA</Link></li>
            </ul>
          </div>

          {/* Contacto */}
          <div className="footer__col">
            <h4 className="footer__title">Contacto</h4>
            <ul className="footer__contact-list">
              {CONTACT.map(({ Icon, text }) => (
                <li key={text}>
                  <span className="footer__contact-icon"><Icon size={15} /></span>
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p className="footer__copy">
            &copy; {year} Impacta M.A. SAS. Todos los derechos reservados.
          </p>
          <p className="footer__legal">
            Reg. Cámara de Comercio · NIT 902.099.926-2
          </p>
        </div>
      </div>
    </footer>
  );
}
